import { FunctionComponent, ReactNode, useEffect, useState } from "react";
import styles from "./MenuBottomBarAtom.module.css";
import { useFocusHandling } from "../../../hooks/useFocusHandling";
import { BadgeNotification } from "@components";

export type MenuBottomBarBaseType = {
  className?: string;

  /** Variant props */
  state?: "default" | "selected";
  icon: ReactNode;
  iconSelected?: ReactNode;
  label?: string;
  badgeLabel?: string;
  onClick?: () => void;
};

const MenuBottomBarBase: FunctionComponent<MenuBottomBarBaseType> = ({
  className = "",
  state: externalState = "default",
  icon,
  iconSelected,
  label = "",
  badgeLabel = "",
  onClick,
}) => {
  const [highlight, setHighlight] = useState(false);
  const [state, setState] = useState(externalState);
  const [showBadge, setShowBadge] = useState(true);

  const { handleFocus, handleBlur } = useFocusHandling({
    isDisabled: false,
    setHighlight,
    onEnter: () => {
      handleClick();
    },
  });

  const handleClick = () => {
    setShowBadge(false);
    setState("selected");
    onClick?.();
  };

  useEffect(() => {
    setState(externalState);
  }, [externalState]);

  useEffect(() => {
    if (badgeLabel && badgeLabel !== "") {
      setShowBadge(true);
    }
  }, [badgeLabel]);

  return (
    <div
      className={[
        styles.root,
        className,
        "quill-ui-next-atom quill-ui-next-pointer",
      ].join(" ")}
      data-state={state}
      data-label={label !== "" ? "yes" : "no"}
      tabIndex={0}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onClick={handleClick}
    >
      <div className={styles.icon1}>
        {state === "selected" ? iconSelected || icon : icon}
      </div>
      <div className={styles.label}>
        {label}
      </div>
      {showBadge && badgeLabel !== "" && (
        <div className={styles.badgeNotification}>
          <BadgeNotification size="sm" label={badgeLabel} />
        </div>
      )}
      {highlight && <div className={styles.bgFocus} />}
    </div>
  );
};

export default MenuBottomBarBase;
